const requestMiddleware = [];

export default function biwFetch( url, options = {} ) {
    requestMiddleware.forEach( ( fn ) => {
        fn( url, options );
    } );

    return fetch( url, options );
}



export function applyRequestMiddleware( fn ) {
    requestMiddleware.push( fn );
}


export async function gql( url, query = '', variables = {} ) {
	const response = await biwFetch( url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify( { query, variables } )
	} );

	return response.json();
}
